<template>
    <Modal
        :opened="isOpen"
        :title="$t('filters.restoreUnpinned.title')"
        :dissmisable="true"
        class="RestoreUnpinnedModal"
        @close="cancel"
    >
        <template #body>
            <div class="RestoreUnpinnedModalBody">
                <WText
                    :size="16"
                    color="gray01"
                    class="RestoreUnpinnedDescription"
                >
                    {{ $t('filters.restoreUnpinned.description') }}
                </WText>
                <div class="RestoreUnpinnedButtons">
                    <WButton
                        outline
                        color="accent-blue"
                        @click="cancel"
                    >
                        {{ $t('filters.restoreUnpinned.cancel') }}
                    </WButton>
                    <WButton
                        @click="restore"
                    >
                        {{ $t('filters.restoreUnpinned.accept') }}
                    </WButton>
                </div>
            </div>
        </template>
    </Modal>
</template>

<script>
import VueTypes from 'vue-types'
import { mapActions } from 'vuex'
import { Modal } from '@/components'

export default {
    name: 'RestoreUnpinnedModal',
    components: { Modal },
    props: {
        isOpen: VueTypes.bool,
    },
    methods: {
        ...mapActions({
            setTemporalUnpinned: 'filters/setTemporalUnpinned',
        }),
        cancel () {
            this.$emit('close')
            this.setTemporalUnpinned({})
        },
        restore () {
            this.$emit('close')
            this.$emit('restore')
        },
    },
}
</script>

<style lang="scss" scoped>
.RestoreUnpinnedModal {
    .RestoreUnpinnedModalBody {
        .RestoreUnpinnedDescription {
            margin-bottom: 15px;
        }
        .RestoreUnpinnedButtons {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            margin-top: 20px;
        }
    }
}
</style>
